import { Tab, Tabs } from '@mui/material';
import Typography from '../../../../../components/Typography/Typography';
import { useTranslation } from '../../../../translation/TranslationContext';
import { useAbility } from '../../../../users/AbilityContext';
import { ExportFormat, ExportTabConfig } from '../ExportOrderModal.types';
import { EXPORT_FORMAT_TABS } from '../utils/exportOrder.consts';

interface ExportOrderTabsProps {
  value: ExportFormat;
  onChange: (format: ExportFormat) => void;
  isOffline?: boolean;
}

const ExportOrderTabs = ({ value, onChange, isOffline }: ExportOrderTabsProps) => {
  const { translate } = useTranslation();
  const ability = useAbility();

  const handleChange = (_: React.SyntheticEvent, next: ExportFormat) => {
    const tabConfig = EXPORT_FORMAT_TABS.find((config) => config.value === next);
    if (isOffline && tabConfig?.disableWhenOffline) {
      return;
    }
    if (tabConfig?.ability && ability.cannot('read', tabConfig.ability)) {
      return;
    }
    onChange(next);
  };

  const disableTab = ({
    disableWhenOffline,
    ability: tabAbility,
  }: Partial<ExportTabConfig>): boolean => {
    return (
      (!!disableWhenOffline && isOffline) || (!!tabAbility && ability.cannot('read', tabAbility))
    );
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      indicatorColor="primary"
      sx={{
        minHeight: 28,
        '& .MuiTabs-indicator': { backgroundColor: 'accent.main' },
        '& .MuiTab-root': {
          flex: 1,
          margin: 0,
          minHeight: 28,
          paddingBottom: '8px',
          '&.Mui-selected': { color: 'accent.main' },
        },
      }}
    >
      {EXPORT_FORMAT_TABS.map(
        ({
          value: formatValue,
          labelKey,
          exportType,
          Icon,
          disableWhenOffline,
          ability: tabAbility,
        }) => (
          <Tab
            key={formatValue}
            value={formatValue}
            disableRipple
            disabled={disableTab({ disableWhenOffline, ability: tabAbility })}
            icon={<Icon />}
            iconPosition="start"
            label={
              <Typography variant="body1-semibold">{`${translate(labelKey)} (${exportType})`}</Typography>
            }
          />
        ),
      )}
    </Tabs>
  );
};

export default ExportOrderTabs;
